var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 16.5V28.5H15.525C13.17 28.5 11.25 30.42 11.25 32.775V16.5C11.25 10.5 12.75 9 18.75 9H29.25C35.25 9 36.75 10.5 36.75 16.5Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 28.5V33.75C36.75 36.645 34.395 39 31.5 39H16.5C13.605 39 11.25 36.645 11.25 33.75V32.775C11.25 30.42 13.17 28.5 15.525 28.5H36.75Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 17.625H18C17.385 17.625 16.875 17.115 16.875 16.5C16.875 15.885 17.385 15.375 18 15.375H30C30.615 15.375 31.125 15.885 31.125 16.5C31.125 17.115 30.615 17.625 30 17.625Z",
    fill: "#111827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 22.875H18C17.385 22.875 16.875 22.365 16.875 21.75C16.875 21.135 17.385 20.625 18 20.625H25.5C26.115 20.625 26.625 21.135 26.625 21.75C26.625 22.365 26.115 22.875 25.5 22.875Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.84cfd8ac4410476285d72f93782878d0.svg";
export { ForwardRef as ReactComponent };